// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1jY02","log":"ModalInventoryLogs_log__2dvm2","date":"ModalInventoryLogs_date__OAXvo","userName":"ModalInventoryLogs_userName__1h5qp"};